<template>
    <div class="main-sections text-center">
        <h2 class="h2 font-weight-bold">How to play?</h2>
        <div class="row align-items-center justify-content-center">
            <div class="col-sm-7 text-center">
                <p class="lead">
                    In recent years, transfers have come under
                    intense scrutiny, making headlines and sparking endless debates. If you love the excitement and
                    drama
                    that unfolds during the transfer window, then this quiz is for you. See if you can guess the player
                    based on their transfer history:
                </p>
            </div>
        </div>

        <div class="game-elements">
            <div class="player-history-container" v-if="selectedGamePlayer">
                <PlayerHistory :transfers="selectedGamePlayer.transfers" />
            </div>
            <p></p>
            <p />
            <base-input ref="playerInputRef" class="player-input" :valid="true" placeholder="Messi"></base-input>
            <p></p>
            <p />
            <div class="row align-items-center justify-content-center">
                <div class="col-sm-7 text-center">
                    <p>
                        The player that made these transfers in his carreer is Lionel Messi, so type Messi and press
                        enter.
                        You will be greeted by a player card showing your correct answer. Press enter (or use the arrow
                        keys) to go to the next player. If you don't know any of the remaining players, you can press
                        "Finish" to end the game and see your score!
                    </p>
                </div>
            </div>
            <p></p>
            <p />
            <div class="player-card-container" v-if="selectedGamePlayer">
                <PlayerCard :selectedGamePlayer="{ player: selectedGamePlayer }" />
            </div>

            <p />
            <p />
            <h3 class="h2 font-weight-bold">Play Now!</h3>
            <p />

            <ButtonRow />
            <p />
        </div>
    </div>
</template>


<script>
import PlayerHistory from './components/PlayerHistory.vue';
import ButtonRow from './components/ButtonRow.vue';
import PlayerCard from './components/PlayerCard.vue';
import axios from 'axios';
import _ from 'lodash';

export default {
    components: {
        PlayerHistory,
        PlayerCard,
        ButtonRow
    },
    data() {
        return {
            selectedGamePlayer: null,
        };
    },
    methods: {
        async getPlayerForExample() {
            try {
                const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
                const response = await axios.get(`${apiBaseUrl}/api/player/154/`);

                this.selectedGamePlayer = response.data
            } catch (error) {
                console.error("An error occurred:", error);
            }

        },
    },
    mounted() {
        this.getPlayerForExample();  // Call the method when the component is mounted
    }
}
</script>

<!-- Styles remain unchanged -->


<style scoped>
.main-sections {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    flex-grow: 1;
}

.game-elements {
    flex: 1;
    /* This allows it to take up available space */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-items: center;

}

.header {
    width: 100%;
    height: 90px;
    margin-bottom: 30px;
}


.player-card-container {
    width: 12em;
    height: 18em;
    max-width: 30vw;
    max-height: 45vw;
}

.col-sm-7 {
    margin-left: 1rem;
    margin-right: 1rem;
}
</style>
